export default class GUI{
	constructor() {
		this.topic = '';
		this.module = null;
		this.question = null;
		this.difficulty = null;

		this.topicData = null;
		this.signals = {
			submit: new P3.utils.MiniSignal()
		};

		this.submit = ()=>{
			this.signals.submit.dispatch();
			// let loc = window.location;
			// window.location.replace(`${loc.protocol}//${loc.host}/?module=${this.module}&question=${this.question}&difficulty=${this.difficulty}`);
			// console.log('clicky click');
		};

		this.guiReferences = {};

		this.loadData();
	}

	loadData(){
		this.data = P3.utils.copyObject(P3.assets.json('locations'));
		let that = this;

		let topics = {};
		for (const datum of this.data) {
			topics[datum.name] = datum.id;
			//topics.push({name: datum.name, id: datum.id});
		}

		console.log(topics);

		this.guiReferences.submit = gui.add(this, 'submit');

		var param = {Topic: this.topic};
		this.guiReferences.topic = gui.add( param, 'Topic', topics ).onFinishChange( function () {
			that.topic = param.Topic;
			for (const data of that.data) {
				if(data.id === that.topic) that.topicData = data
			}
			that.setModuleDropDown();
			console.log(that.topic);
		} );
	}

	setModuleDropDown(){
		console.log(this.topicData);
		let modules = [];

		for (const module in this.topicData.modules) {
			modules.push({
				name: module,
				questions: this.topicData.modules[module]
			});
		}

		modules.push({
			name: '//',
			questions: null
		});

		console.log(modules);
		let param = {module: ''};

		let t = {};
		for (const module of modules) {
			t[module.name] = module.name;
		}

		let that = this;
		if(this.guiReferences.module){
			gui.remove(this.guiReferences.module);
			this.guiReferences.module = null;
		}
		if(this.guiReferences.question){
			gui.remove(this.guiReferences.question);
			this.guiReferences.question = null;
		}
		if(this.guiReferences.difficulty){
			gui.remove(this.guiReferences.difficulty);
			this.guiReferences.difficulty = null;
		}
		this.guiReferences.module = gui.add( param, 'module', t ).onFinishChange( function () {
			that.module = param.module;
			that.setQuestionDropDown();
			console.log(that.module);
		} );
	}

	setQuestionDropDown(){
		let param = {question: ''};

		let questions = [];

		for (const module in this.topicData.modules) {
			if(module === this.module){
				for (const question of this.topicData.modules[module]) {
					questions.push(question);
				}
				break;
			}
		}

		let t = {};
		for (const question of questions) {
			t[question] = question;
		}

		t['//'] = '//';

		let that = this;
		if(this.guiReferences.question){
			gui.remove(this.guiReferences.question);
			this.guiReferences.question = null;
		}
		if(this.guiReferences.difficulty){
			gui.remove(this.guiReferences.difficulty);
			this.guiReferences.difficulty = null;
		}
		this.guiReferences.question = gui.add( param, 'question', t ).onFinishChange( function () {
			that.question = param.question;
			that.setDifficultyDropDown();
			console.log(that.question);
		} );
	}

	setDifficultyDropDown(){

		let difficulties = [];

		let questions = P3.assets.json('questions');
		const staticQuestions = P3.assets.json('static_questions');
		questions.static = staticQuestions.static;
		for (const question in questions) {
			if(question === this.module){
				for (const questionElement of questions[question]) {
					if(this.question === questionElement.type && questionElement.enabled){
						difficulties.push(questionElement.difficulty);
					}
				}
			}
		}

		difficulties.push('//');


		if(this.guiReferences.difficulty){
			gui.remove(this.guiReferences.difficulty);
			this.guiReferences.difficulty = null;
		}

		let that = this;
		let param = {difficulty: ''};
		//this.guiReferences.difficulty = gui.add(this, 'difficulty', 0, 3).step(1);
		this.guiReferences.difficulty = gui.add( param, 'difficulty', difficulties).onFinishChange( function () {
			that.difficulty = param.difficulty;
			console.log(that.difficulty);
		} );
	}
}